export default __webpack_public_path__ + "static/media/email.ecdb0d4d.svg";